// Goals Service - Issue #15: Goal Completion Tracking UI
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

// Create axios instance with default config
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add auth token to requests
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

const goalsService = {
    // Create a new goal
    createGoal: async (goalData) => {
        try {
            const response = await api.post('/goals', goalData);
            return response.data;
        } catch (error) {
            console.error('Error creating goal:', error);
            throw error.response?.data || error;
        }
    },

    // Get employee goals
    getEmployeeGoals: async (employeeId, filters = {}) => {
        try {
            const params = new URLSearchParams();
            if (filters.status) params.append('status', filters.status);
            if (filters.priority) params.append('priority', filters.priority);

            const response = await api.get(
                `/goals/employee/${employeeId}?${params.toString()}`
            );
            return response.data;
        } catch (error) {
            console.error('Error fetching employee goals:', error);
            throw error.response?.data || error;
        }
    },

    // Get team goals (for managers)
    getTeamGoals: async () => {
        try {
            const response = await api.get('/goals/team');
            return response.data;
        } catch (error) {
            console.error('Error fetching team goals:', error);
            throw error.response?.data || error;
        }
    },

    // Update a goal
    updateGoal: async (goalId, updates) => {
        try {
            const response = await api.put(`/goals/${goalId}`, updates);
            return response.data;
        } catch (error) {
            console.error('Error updating goal:', error);
            throw error.response?.data || error;
        }
    },

    // Delete a goal
    deleteGoal: async (goalId) => {
        try {
            const response = await api.delete(`/goals/${goalId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting goal:', error);
            throw error.response?.data || error;
        }
    },

    // Mark goal as complete
    completeGoal: async (goalId) => {
        try {
            const response = await api.patch(`/goals/${goalId}/complete`);
            return response.data;
        } catch (error) {
            console.error('Error completing goal:', error);
            throw error.response?.data || error;
        }
    }
};

export default goalsService;
